/**
 * Moderator Approvals API Endpoints
 * Integrates with /api/moderator-approvals backend endpoints
 */

import apiClient from '../client'
import type {
  WorkflowApprovalNodeGroupDto,
  ApprovalResultDto,
  ApproveRequest,
  DenyRequest,
  BulkApproveRequest,
} from '../types/moderatorApprovals'

const BASE_URL = '/api/moderator-approvals'

export const moderatorApprovalsApi = {
  /**
   * Get all pending approval requests grouped by adventure/node
   * GET /api/moderator-approvals/pending
   */
  getPending: async (): Promise<WorkflowApprovalNodeGroupDto[]> => {
    const response = await apiClient.get(`${BASE_URL}/pending`)
    return response.data
  },

  /**
   * Approve a specific request
   * POST /api/moderator-approvals/{requestId}/approve
   */
  approve: async (requestId: string, notes?: string): Promise<ApprovalResultDto> => {
    const body: ApproveRequest = notes ? { notes } : {}
    const response = await apiClient.post(`${BASE_URL}/${requestId}/approve`, body)
    return response.data
  },

  /**
   * Deny a specific request
   * POST /api/moderator-approvals/{requestId}/deny
   */
  deny: async (requestId: string, reason?: string): Promise<ApprovalResultDto> => {
    const body: DenyRequest = reason ? { reason } : {}
    const response = await apiClient.post(`${BASE_URL}/${requestId}/deny`, body)
    return response.data
  },

  /**
   * Bulk approve all (or specific) requests for an adventure/node
   * POST /api/moderator-approvals/bulk-approve
   */
  bulkApprove: async (
    adventureId: string,
    nodeId: string,
    requestIds?: string[],
    notes?: string
  ): Promise<ApprovalResultDto> => {
    const body: BulkApproveRequest = { adventureId, nodeId, requestIds, notes }
    const response = await apiClient.post(`${BASE_URL}/bulk-approve`, body)
    return response.data
  },
}
